export default __webpack_public_path__ + "static/media/field-devices.630feb51.PNG";